/**
 * ProcessProgressBar — Linear progress bar with shimmer effect.
 */
export default function ProcessProgressBar({ completed = 0, total = 1 }) {
  const progress = total > 0 ? (completed / total) * 100 : 0;
  const isComplete = completed >= total;

  return (
    <div className="w-full">
      <div className="flex items-center justify-between mb-1">
        <span className="text-xs text-gray-400">
          {isComplete ? 'Complete' : `${completed}/${total} steps`}
        </span>
        <span className="text-xs text-gray-400">{Math.round(progress)}%</span>
      </div>
      <div className="h-1.5 bg-gray-100 rounded-full overflow-hidden">
        <div
          className={`h-full rounded-full transition-all duration-500 ease-out ${
            isComplete ? 'bg-green-500' : 'bg-blue-500'
          }`}
          style={{ width: `${progress}%` }}
        >
          {!isComplete && (
            <div
              className="h-full w-full"
              style={{
                background: 'linear-gradient(90deg, transparent 0%, rgba(255,255,255,0.4) 50%, transparent 100%)',
                backgroundSize: '200% 100%',
                animation: 'shimmer 1.5s ease-in-out infinite',
              }}
            />
          )}
        </div>
      </div>
    </div>
  );
}
